import { apmStatics } from '@support/utils';
export default () => {
  if (process.client) {
    apmStatics();
  }
};
